import {HttpClient} from '@angular/common/http';
import {EventEmitter, Injectable} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ActiveCartFacade, Cart, MultiCartFacade} from '@spartacus/cart/base/root';
import {DynamicAttributes, EventService, OccEndpointsService, UserIdService} from '@spartacus/core';
import {EMPTY, Observable, Subject} from 'rxjs';
import {concatMap, first} from 'rxjs/operators';
import {CartService} from '@dcp/configurator'

/**
 * Messages the poNumberSubmit is expected to emit.
 */
export const enum PO_NUMBER_ACTIONS {
  poNumberCurrentSaveRequestPending = 'poNumberCurrentSaveRequestPending',
  poNumberCurrentSaveRequestFinishedSuccessfully = 'poNumberCurrentSaveRequestFinishedSuccessfully',
  poNumberCurrentSaveRequestFinishedWithErrors = 'poNumberCurrentSaveRequestFinishedWithErrors',
  poNumberSaved = 'poNumberSaved',
  sendPoNumber = 'sendPoNumber',
  error = 'error',
  placeOrder = 'placeOrder'
}

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DcpCartService extends CartService {

  /**
   * Subscribes or unsubscribes to cart changes when the cart-entry-edit-modal is closed or opened.
   */
  public cartSubscriptionStatus: EventEmitter<string> = new EventEmitter<'subscribe' | 'unsubscribe'>();

  /**
   * Is triggered when the po Number has been sent to the backend.
   */
  private poNumberSubject$ = new Subject<PO_NUMBER_ACTIONS>();

  constructor(
    protected activeCartFacade: ActiveCartFacade,
    protected multiCartFacade: MultiCartFacade,
    protected userIdService: UserIdService,
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    protected eventService: EventService
  ) {
    super(activeCartFacade, multiCartFacade, userIdService, eventService);
  }

  public emitPoNumberMessage(action: PO_NUMBER_ACTIONS) {
    this.poNumberSubject$.next(action);
  }

  public getPoNumberMessage$(): Observable<string> {
    return this.poNumberSubject$.asObservable();
  }

  /**
   * Calls checkoutService.getOrderDetails while making sure that the feature toggle is active.
   */
  savePoNumber(purchaseOrderNumber: string): Observable<Cart> {
    if (purchaseOrderNumber === null || purchaseOrderNumber === undefined) {
      return EMPTY;
    }
    return this.userIdService.getUserId().pipe(first(), concatMap((userId) => this.activeCartFacade.getActiveCartId().pipe(first(), concatMap((cartId) => {
      const urlParam: DynamicAttributes = {
        urlParams: {userId, cartId} // refactored urlParam to fit new OccEndpointsService.buildUrl() arguments
      };
      return this.http.put<Cart>(
        this.occEndpointsService.buildUrl('cartPurchaseOrderNumber', urlParam),
        {},
        {params: {purchaseOrderNumber}}
      );
    }), untilDestroyed(this))), untilDestroyed(this));
  }
}
